import React from "react";

const EDITORIAL_IMG = "https://customer-assets.emergentagent.com/job_atelier-tall/artifacts/rklzh7kr_ChatGPT%20Image%20May%2019%2C%202026%2C%2001_16_17%20PM.png";

const PROMISES = [
  ["Inseams to 34\"", "Drafted on tall fit models."],
  ["Hems +4–6cm", "Tees, sweats and rugby tops that hold their proportion."],
  ["Sleeves +2–3cm", "Knits that reach the wrist."],
  ["Tonal TIA embroidery", "A quiet signature on every piece."],
];

export const EditorialPromise = () => (
  <section className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-20 sm:py-32 grid grid-cols-12 gap-6 lg:gap-12 items-center" data-testid="editorial-promise">
    <div className="col-span-12 lg:col-span-5">
      <div className="aspect-[4/5] overflow-hidden bg-[#efe6db]">
        <img src={EDITORIAL_IMG} alt="Editorial — The Striped Set" className="w-full h-full object-cover" style={{ objectPosition: "20% 30%" }} />
      </div>
    </div>
    <div className="col-span-12 lg:col-span-6 lg:col-start-7 mt-8 lg:mt-0">
      <div className="micro-label text-[#1a1814]/60 mb-5 sm:mb-6">Made for height</div>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-6xl text-[#1a1814] leading-[1.1] lg:leading-[1.05] max-w-xl">
        Every pattern is graded a second time — for a body that begins where most designs end.
      </h2>
      <ul className="mt-10 sm:mt-12 space-y-5 max-w-md">
        {PROMISES.map(([h, c]) => (
          <li key={h} className="flex gap-5 sm:gap-6">
            <span className="font-serif text-[#1a1814]/40 text-lg shrink-0">—</span>
            <div>
              <div className="font-serif text-xl">{h}</div>
              <div className="text-sm text-[#1a1814]/70">{c}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
